export enum TabValue {
  CurrentSeason = 'Current Season',
  AllTime = 'All time',
  Referrals = 'Referrals',
}
